import Splide from '@splidejs/splide';
import './primo-piano-slider.scss';

export class PrimoPianoSlider {
  constructor() {
    this.el = document.querySelector('.js-primo-piano-slider');
    if (!this.el) return;

    this.init();
  }

  init() {
    const splide = new Splide(this.el, {
      type: 'slide',
      arrows: false,
      pagination: false,
      gap: '24px',
      perPage: 3,
      focus: 0,
      destroy: false,
      drag: false,
      breakpoints: {
        992: {
          destroy: false,
          arrows: true,
          perPage: 2.2,
          padding: { right: '20px' },
          drag: true,
        },
        768: {
          destroy: false,
          arrows: true,
          perPage: 1.2,
          padding: { right: '20px' },
          drag: true,
        },
      },
    });

    splide.mount();
  }
}
